import React from 'react';
import DashboardNew from './DashboardNew.react';
import {connect} from 'react-redux'
import Progress from './layout/Progress.react';
import * as CampaignActions from '../actions/campaign';
import * as DocumentStorageActions from '../actions/documentStorage';
import DashboardIntro from './DashboardIntro.react';
import DashboardList from './DashboardList.react';
import {FormattedMessage} from 'react-intl';
import {Tab, Tabs, TabList, TabPanel} from 'react-tabs';
import Joyride from 'react-joyride';
import './../../../dist/theme/src/react-joyride-compiled.css'

class Dashboard extends React.Component {

    constructor(props) {
        super(props);

        this.handleSelect = this.handleSelect.bind(this);

        this.state = {
            joyrideOverlay: true,
            joyrideType: 'continuous',
            isRunning: false,
            autoStart: false,
            stepIndex: 0,
            steps: [],
            selector: '',
            firstVisitDashboard: true,
            activeTabIndex: 0
        };
    }

    componentWillMount() {

        const firstVisitDashboard = this.checkFirstVisitDashboard();

        this.setState ({
            firstVisitDashboard: firstVisitDashboard,
            activeTabIndex: (firstVisitDashboard ? 0 : 1)
        });
    }


    componentDidMount() {

        // call dispatch
        let {dispatch} = this.props;
        dispatch(CampaignActions.getCampaigns());


        dispatch(DocumentStorageActions.getDocumentStorages());

        // check if user has already visited the page, if true => feature tour will be activated
        /*if(this.state.firstVisitDashboard) {
            setTimeout(() => {
                this.startTour();
            }, 100);
        }*/

        const steps = [
            {
                title: <FormattedMessage id='TEXT_FEATURE_TOUR_DASHBOARD_TITLE_1' />,
                text: <FormattedMessage id='TEXT_FEATURE_TOUR_DASHBOARD_MESSAGE_1' />,
                selector: '.tab-navigation',
                position: 'bottom',
            },
            {
                title: <FormattedMessage id='TEXT_FEATURE_TOUR_DASHBOARD_TITLE_2' />,
                text: <FormattedMessage id='TEXT_FEATURE_TOUR_DASHBOARD_MESSAGE_2' />,
                selector: '.dashboard-intro',
                position: 'top-right',
            },
            {
                title: <FormattedMessage id='TEXT_FEATURE_TOUR_DASHBOARD_TITLE_3' />,
                text: <FormattedMessage id='TEXT_FEATURE_TOUR_DASHBOARD_MESSAGE_3' />,
                selector: '.dashboard-list',
                position: 'right'
            },
            {
                title: <FormattedMessage id='TEXT_FEATURE_TOUR_DASHBOARD_TITLE_4' />,
                text: <FormattedMessage id='TEXT_FEATURE_TOUR_DASHBOARD_MESSAGE_4' />,
                selector: '.campaign-list',
                position: 'top',
            }

        ];

        this.addSteps(steps);

    }

    /** Checks if user visits the page for the first time*/
    checkFirstVisitDashboard() {

        if (localStorage.getItem("firstVisitDashboard") === null) {
            localStorage.setItem("firstVisitDashboard", false);
            return true;
        } else {
            return false;
        }
    }

    /** Feature Tour Steps*/
    addSteps(steps) {

        let newSteps = steps;

        if (!Array.isArray(newSteps)) {
            newSteps = [newSteps];
        }

        if (!newSteps.length) {
            return;
        }

        // Force setState to be synchronous to keep step order.
        this.setState(currentState => {
            currentState.steps = currentState.steps.concat(newSteps);
            return currentState;
        });
    }

    /** Starts Feature Tour*/
    startTour() {

        // switch to first tab
        this.setState({
            activeTabIndex: 0
        });

        if (!this.state.isRunning) {
            // first time
            this.setState({
                isRunning: true,
                autoStart: true
            });
        } else {
            this.refs.joyride.reset(true);
        }
    }

    /** Feature Tour Events*/
    callback(data) {

        // resets tour data after closing
        if(data.action === 'close') {
            this.refs.joyride.reset();
        }

        // handles tab transition
        if(data.type === 'step:after' && data.index === 1) {
            this.setState ({
                isRunning: false,
                activeTabIndex: 1,
            });
            setTimeout(() => {
                this.setState ({
                    isRunning: true
                });
            }, 100);
        }
    }

    handleSelect(index, last) {
        console.log('handle select', index);
        const newState = {
            ...this.state,
            activeTabIndex: index,
        };
        localStorage.setItem("dashboard-active-tab-index", index);
        this.setState(newState);
    }

    render() {
        const {campaign, documentStorage} = this.props;
        // const dashboardIntro = '/api/pdfproduct/send/' + storage.id;

        const {
            isRunning,
            autoStart,
            joyrideOverlay,
            joyrideType,
            stepIndex,
            steps,
            activeTabIndex
        } = this.state;

        if (campaign.loaded === false && documentStorage.loaded === false) {
            return <Progress />
        }

        let mainContent = <div></div>;
        if (documentStorage.data && documentStorage.data.length > 0) {
            mainContent = <DashboardList documentStorage={documentStorage}/>;
        } else {
            mainContent = <DashboardIntro/>;
        }

        const tabIndex = parseInt(localStorage.getItem("dashboard-active-tab-index") ? localStorage.getItem("dashboard-active-tab-index") : activeTabIndex);

        return (
            <div>
                <Joyride
                    ref="joyride"
                    callback={this.callback.bind(this)}
                    disableOverlay={false}
                    locale={{
                        back: (<span><FormattedMessage id="LABEL_FEATURE_TOUR_BACK"/></span>),
                        close: (<span><FormattedMessage id="LABEL_FEATURE_TOUR_CLOSE"/></span>),
                        last: (<span><FormattedMessage id="LABEL_FEATURE_TOUR_LAST"/></span>),
                        next: (<span><FormattedMessage id="LABEL_FEATURE_TOUR_NEXT"/></span>),
                        skip: (<span><FormattedMessage id="LABEL_FEATURE_TOUR_SKIP"/></span>),
                    }}
                    run={isRunning}
                    autoStart={autoStart}
                    showOverlay={joyrideOverlay}
                    showSkipButton={true}
                    showStepsProgress={true}
                    stepIndex={stepIndex}
                    steps={steps}
                    type={joyrideType}
                />
                <section className="container">
                    {/*<div onClick={this.startTour.bind(this)} className="joyride-start-area">
                        <i className="material-icons joyride-start-icon">help</i>
                        <FormattedMessage id="LABEL_FEATURE_TOUR"/>
                    </div>*/}
                    <Tabs ref="tabs" onSelect={this.handleSelect} selectedIndex={tabIndex}>
                        <TabList className="tab-navigation">
                            <Tab><FormattedMessage id="LABEL_INTRODUCTION"/></Tab>
                            <Tab><FormattedMessage id="LABEL_CREATE_NEW_STORAGE"/></Tab>
                            <Tab><FormattedMessage id="LABEL_DOCUMENT_LIST"/></Tab>
                        </TabList>
                        <TabPanel>
                            <section className="row">
                                <div className="col-sm-12 dashboard-intro">
                                    <DashboardIntro/>
                                </div>
                            </section>
                        </TabPanel>

                        <TabPanel>
                            <section className="row">
                                <div className="col-sm-12 dashboard-new">
                                    <DashboardNew campaign={campaign} />
                                </div>
                            </section>
                        </TabPanel>

                        <TabPanel>
                            <section className="row">
                                <div className="col-md-12 dashboard-list">
                                    { mainContent }
                                </div>
                            </section>
                        </TabPanel>
                    </Tabs>
                </section>
            </div>
        );
    }
}

export default connect(state => ({campaign: state.campaign, documentStorage: state.documentStorage}))(Dashboard);


// WEBPACK FOOTER //
// ./src/js/components/Dashboard.react.jsx